import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { BACKEND_APIS } from "@constants"
import { europcarCompaniesFilter } from "Pages/BusinessLogistics/Analytics/Page/@signals"
import React from "react"

export default function EuropcarCompanySelector() {

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		urlAjax={`${BACKEND_APIS.EUROPCAR_ANALYTICS}/companies`}
		value={europcarCompaniesFilter.value}
		onChange={(({ target }) => europcarCompaniesFilter.value = target.value)}
		label="Companies"
		placeholder="Select a company to filter"
	/>
}